// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"b80d7a35","314":"71a538e7","422":"55a051f5","666":"809b5176","869":"c45f7af0"}[chunkId] + ".chunk.js";
};